import Stack from "@mui/material/Stack";
import { Button, Input, Modal } from "@vv/ui";
import { useState } from "react";

export interface RejectModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

export function RejectModal({ open, onClose, onConfirm }: RejectModalProps) {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleConfirm() {
    setSaving(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
    } catch {
      // Already toasted by the caller's runAction() - swallow so it doesn't
      // also surface as an unhandled promise rejection.
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Reject request"
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="contained"
            color="error"
            loading={saving}
            disabled={reason.trim().length === 0}
            onClick={handleConfirm}
          >
            Reject
          </Button>
        </>
      }
    >
      <Stack spacing={2} sx={{ pt: 1 }}>
        <Input
          label="Rejection reason"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          multiline
          minRows={3}
          required
          autoFocus
        />
      </Stack>
    </Modal>
  );
}
